import type {
  DataFetchParams,
  DataFetchResponse,
  FilterOptionsParams,
  DynamicFilterOptionsPage,
} from '@/components/DataTable';
import {
  listRunningNowDataTable,
  getRunningNowFilterOptions,
} from '@kirin/api-client/api/shadow-ai';
import type {
  RunningNowListItem,
  RunningNowFilterOptionField,
  RunningNowSortField,
} from '@kirin/api-client/contracts/shadow-ai-running-now';
import { apiClient } from '@/lib/api-client';

export async function fetchRunningNow(
  organizationId: string,
  params: DataFetchParams,
  signal?: AbortSignal,
  isRoot?: true,
  scopeUserId?: string
): Promise<DataFetchResponse<RunningNowListItem>> {
  const sortField = params.sort?.field as RunningNowSortField | undefined;
  const response = await listRunningNowDataTable(
    apiClient,
    organizationId,
    {
      page: params.pagination.pageIndex + 1,
      limit: params.pagination.pageSize,
      filters: params.filters,
      sortBy: sortField,
      sortOrder: params.sort?.order,
      search: params.search,
      isRoot,
      knownTotal: params.knownTotal,
      scopeUserId,
    },
    { signal }
  );

  return {
    data: response.data,
    pagination: response.pagination,
    meta: {
      activeFilters: response.meta?.activeFilters ?? [],
      search: response.meta?.search,
    },
  };
}

export async function fetchRunningNowFilterOptions(
  organizationId: string,
  field: RunningNowFilterOptionField,
  params: FilterOptionsParams,
  scopeUserId?: string
): Promise<DynamicFilterOptionsPage> {
  const response = await getRunningNowFilterOptions(apiClient, organizationId, {
    field,
    search: params.search,
    limit: params.limit,
    offset: params.offset,
    scopeUserId,
  });

  return {
    options: response.options,
    total: response.pagination.total,
    nextOffset: response.pagination.nextOffset ?? null,
    hasMore: response.pagination.hasMore,
  };
}
